import * as React from 'react';
import { Link } from 'gatsby';
import * as styles from '../styles/footer.module.scss';
import ReactMarkdown from 'react-markdown';
import { useStaticQuery, graphql } from 'gatsby';

function Footer({ focusMode, siteTitle, logo, description }) {
  const result = useStaticQuery(
    graphql`
      {
        cms {
          pages(
            where: {
              _or: [
                { type: "connect_company" }
                { type: "terms" }
                { type: "contact" }
              ]
            }
          ) {
            type
            title
            slug
            sites {
              url
            }
          }
        }
      }
    `,
  );

  const pages = result.cms.pages.filter((page) =>
    page.sites.some((site) => site.url === process.env.GATSBY_FRONTEND_DOMAIN),
  );

  const order = ['terms', 'connect_company', 'contact'];
  pages.sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type));

  return (
    <footer>
      <div className="grid cols-2 sm-stack">
        <div>
          <Link to="/">
            <img
              width={350}
              height={'100%'}
              style={{ filter: 'brightness(0) invert(1)' }}
              src={logo}
              alt={siteTitle}
            />
          </Link>
          {!focusMode ? (
            <>
              {process.env && process.env.GATSBY_USER_LOCALE === 'sv' ? (
                <address>
                  Servicestart Sverige AB
                  <br /> Övre Slottsgatan 6 <br />
                  753 10 Uppsala
                </address>
              ) : (
                <address>
                  Servicestart Ltd / Square Root Business Centre <br />
                  102-116 Windmill Road, Croydon <br />
                  Surrey, CR0 2XQ
                </address>
              )}
            </>
          ) : null}
        </div>
        {!focusMode ? (
          <div>
            <ReactMarkdown>{description}</ReactMarkdown>
          </div>
        ) : null}
      </div>

      {!focusMode ? (
        <>
          <ul className={styles.footerNav}>
            {pages.map((page) => (
              <li key={page.slug}>
                <Link to={`/${page.slug}#header`}>{page.title}</Link>
              </li>
            ))}
          </ul>
          <small>
            &copy; {new Date().getFullYear()} {siteTitle}
          </small>
        </>
      ) : (
        ''
      )}
    </footer>
  );
}
export default Footer;
